export const normalizePhoneInput = (value: string) => {
  if (!value) {
    return value
  }

  if (value === "3") {
    return "+393"
  }

  if (value.startsWith("00")) {
    value = value.replace("00", "")
  }

  return `+${value.replace(/[^\d]/g, "")}`.substring(0, 13)
}

export const isValidPhone = (value: string, allowEmpty = false) => {
  if (!value.startsWith("+")) {
    return false
  }
  if (allowEmpty && value.trim().length === 3) {
    return true
  }
  if (value.trim().length < 12) {
    return false
  }
  return true
}
